var footer = require('../../shared/footer')

module.exports = {
  url: '/',
  template: require('raw!templates/home/home.html'),
  controller: HomeController,
  controllerAs: 'homeCtrl'
}

function HomeController ($scope, $state, store, contentful,  $uibModal, $window) {
  $scope.page = 'home'
  $window.scrollTo(0,0);
  contentful.entries('content_type=home').then(function(res) {
    var seoData = res.data.items[0];
    if (seoData.fields.pageTitleSeo) {
      document.title = seoData.fields.pageTitleSeo;
    }
    if (seoData.fields.pageSpecificMetaDescriptionSeo) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = seoData.fields.pageSpecificMetaDescriptionSeo;
        }
      }
    }
  });
  var left = true
  $scope.setSelectedService = function (service) {
    store.set('selectedService', service)
  }
  contentful.entries('content_type=serviceTypes').then(function(res) {
  $scope.allServices= res.data.items;
  $scope.serviceDetail= res.data.items[0];
  });
  $scope.certsLeft = []
  $scope.certsRight = []
  contentful.entries('content_type=home').then(function(res) {
    $scope.contentfulData = res.data.items[0];
    angular.forEach($scope.contentfulData.fields.certsAndLicenses, function(entry) {
      if(left === true) {
        $scope.certsLeft.push(entry)
        left = false
      } else {
        $scope.certsRight.push(entry)
        left = true
      }
    })
  })
  $scope.allServicesProvided = []
  $scope.allServiceTypes = []
  $scope.goToService = function (service) {
  }
  $scope.goToWorkProjects = function (workProjects) {
  }
  $scope.allWorkProjects = []
  contentful.entries('content_type=workProjects').then(function(res) {
    $scope.allWorkProjects = res.data.items
  })
  $("a[href^='#']").on('click', function(e) {

     // prevent default anchor click behavior
     e.preventDefault();

     // animate
     $('html, body').animate({
         scrollTop: $(this.hash).offset().top
       }, 300, function(){

         // when done, add hash to url
         // (default click behaviour)
         window.location.hash = this.hash;
       });

  });
}



/** WEBPACK FOOTER **
 ** ./components/templates/home/home.js
 **/